import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

export default function Details() {
  const { t } = useLanguage();
  
  const icons = ['MapPin', 'Globe', 'CreditCard', 'Sun', 'Phone', 'Gift'];
  const links = [
    'https://colombia.travel/en/cartagena-de-indias',
    'https://www.passportindex.org/',
    'https://www.numbeo.com/cost-of-living/in/Cartagena',
    null, null, null
  ];

  const items = t('details.items');

  return (
    <section id="details" className="py-24 lg:py-32 px-4 bg-white relative">
      <div className="max-w-6xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <span className="text-brand-accent text-xs uppercase tracking-[0.4em] font-bold mb-4 block">
            {t('details.label')}
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-brand-dark mb-6">{t('details.title')}</h2>
          <div className="w-12 h-[1px] bg-brand-accent mx-auto mb-8" />
          <p className="text-brand-dark/70 max-w-2xl mx-auto leading-relaxed text-lg font-light">
            {t('details.desc')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
          {items.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="flex flex-col items-center text-center group p-8 rounded-2xl hover:bg-brand-light/50 transition-colors duration-500 border border-transparent hover:border-brand-muted/30"
            >
              <div className="mb-6 w-14 h-14 flex items-center justify-center rounded-full bg-brand-light text-brand-accent group-hover:bg-brand-accent group-hover:text-white transition-all duration-500">
                <SafeIcon name={icons[index]} className="text-2xl" />
              </div>
              <h3 className="font-serif text-2xl text-brand-dark mb-4">{item.title}</h3>
              <p className="text-brand-dark/60 text-sm leading-relaxed mb-4 whitespace-pre-line">
                {item.desc}
              </p>
              {links[index] && (
                <a
                  href={links[index]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-auto text-brand-accent text-xs uppercase tracking-widest font-semibold hover:text-brand-dark transition-colors flex items-center gap-2"
                >
                  {item.linkText}
                  <SafeIcon name="ExternalLink" className="text-[10px]" />
                </a>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}